import { Option } from 'commander';
import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { SyncOptions } from './types/SyncOptions.js';
import { reusedOptions } from '../../utilities/reusedOptions.js';

/** Defines the "sync" verb. */
export const init: CommandInitFunction = (program) => {
  program.addSubCommand<SyncOptions>({
    name: 'sync',
    description:
      'Syncs packages from/to the remote cache. ' +
      'By default (without --upload) it will download any packages not found in the local cache.',
    options: {
      upload: new Option('--upload', 'Upload packages to the remote cache (instead of downloading).'),
      login: reusedOptions.login('sync'),
    },
    getExecutor: () => import('./execute.js'),
  });
};
